import { getStartTime, getEndTime } from 'find-and-filter-data/search-and-filter-schema/protected';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useFilterValues } from 'find-and-filter-data/search-and-filter-data/public';
import { timestampToSimpleDate } from '../operators/dateFilterOperators';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import { toMoment } from 'UIComponents/core/SimpleDate';
import { ONE_DAY } from '../../constants/Dates';
import debounce from 'react-utils/debounce';
import { useState } from 'react';
import { DateRange } from 'foundations-components/transitional/components/DateRange';
import { jsx as _jsx } from "react/jsx-runtime";
const debouncedOnChange = debounce((startDate, endDate, setFilterValues) => {
  const startTime = toMoment(startDate).valueOf();
  const endTime = toMoment(endDate).valueOf() + ONE_DAY - 1;
  // -1 here is to make sure we don't show it as second day
  setFilterValues({
    startTimestamp: startTime,
    endTimestamp: endTime
  });
}, 500);
const DateFilter = () => {
  const {
    filterValues,
    setFilterValues
  } = useFilterValues();
  const [displayValue, setDisplayValue] = useState({
    endDate: timestampToSimpleDate(getEndTime(filterValues)),
    startDate: timestampToSimpleDate(getStartTime(filterValues))
  });
  const handleOnChange = evt => {
    const {
      startDate,
      endDate
    } = evt.currentTarget.value;
    setDisplayValue({
      startDate,
      endDate
    });
    debouncedOnChange(startDate, endDate, setFilterValues);
  };
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.date.title"
    }),
    children: /*#__PURE__*/_jsx(DateRange, {
      "data-test-id": "date-filter",
      onChange: handleOnChange,
      display: "block",
      value: displayValue
    })
  });
};
DateFilter.displayName = 'DateFilter';
export default DateFilter;